import { Select, Typography, SelectChangeEvent } from '@mui/material';
import { WalletTypes } from '@constants/enums';
import { useState } from 'react';
import { useCurrencySelector } from '../../hooks/useCurrencySelector';
import type { SelectorTypeProps } from '../../types';
import { AccountsGroup } from './AccountsGroup';
import CurrencySelectorStyles from './CurrencySelector.style';

const CurrencySelector = ({
  defaultCurrency,
  walletType,
  onCurrencyChange,
  disabled = false,
}: SelectorTypeProps) => {
  const { findDefaultWalletUuid, globalAccounts, loanAccounts, translations } =
    useCurrencySelector();

  const defaultUuid = findDefaultWalletUuid(defaultCurrency, walletType);
  const [selectedUuid, setSelectedUuid] = useState(defaultUuid);

  const handleCurrencyChange = (event: SelectChangeEvent<string>) => {
    const walletUuid = event.target.value;
    setSelectedUuid(walletUuid);
    onCurrencyChange(walletUuid);
  };

  return (
    <section className={CurrencySelectorStyles.wrapper}>
      <Typography variant="caption" component="p">
        {translations.selectorTitle}
      </Typography>
      <Select
        id="currency"
        className={CurrencySelectorStyles.selector}
        value={selectedUuid}
        onChange={handleCurrencyChange}
        disabled={disabled}
      >
        {[
          ...AccountsGroup({
            accounts: globalAccounts,
            accountType: WalletTypes.GLOBAL_ACCOUNT,
            groupTitle: translations.globalAccountTitle,
            tooltipTitle: translations.globalAccountTooltip,
          }),
          ...AccountsGroup({
            accounts: loanAccounts,
            accountType: WalletTypes.LOAN_ACCOUNT,
            groupTitle: translations.loanAccountTitle,
            tooltipTitle: translations.loanAccountTooltip,
          }),
        ]}
      </Select>
    </section>
  );
};

export default CurrencySelector;
